import { Palette } from '@material-ui/core/styles/createPalette';

// Colors
export const transparent = 'rgba(255, 255, 255, 0)';
export const white = '#fff';
export const black = '#000';

export const robinsEggBlue = '#00bdbd';
export const daltonsRed = '#ec663e';
export const cornflowerBlue = '#6189fb';
export const tiaMariaOrange = '#d73f12';
export const pirateGoldOrange = '#c78100';
export const capeCodGray = '#364343';
export const osloGray = '#869191';
export const nevadaGray = '#626f6f';
export const eduardGray = '#a3adad';
export const geyserGray = '#d1dfdf';
export const mysticGray = '#e3eded';
export const aquaHazeGray = '#f4f8f8';
export const zirconGray = '#f2f5ff';

export const selectiveYellow = '#f4bb02';
export const sunGlowYellow = '#ffce2e';
export const lightningYellow = '#f9c314';
export const malibuBlue = '#7fa0ff';
export const vividViolet = '#753a92';
export const periwinkleBlue = '#bfcfff';

export const cinnabarRed = '#e23c3b';
export const bossanovaViolet = '#502664';
export const blue = '#0202ea';

// MUI Palette
export const palette: Partial<Palette> = {
  background: {
    default: '#fcfcfd',
    paper: '#fff',
  },
  common: {
    white,
    black,
  },
  primary: {
    main: malibuBlue,
    dark: malibuBlue,
    light: periwinkleBlue,
    contrastText: white,
  },
  secondary: {
    main: nevadaGray,
    dark: nevadaGray,
    light: osloGray,
    contrastText: white,
  },
  text: {
    primary: capeCodGray,
    secondary: cornflowerBlue,
    disabled: capeCodGray,
    hint: osloGray,
  },
};
